<template lang="pug">
div
  .page-header
    .row
      .col-md-6
        h1 {{ title }}
      .col-md-5.col-md-offset-1.flex.justify-end
        .text-right(v-if='voltar')
          a.btn.btn-default(type='button', :href='getUrl()' @click.prevent="getVoltar") Voltar
        .text-right(v-if='titleNew')
          router-link(:to='`${url}novo`').btn.btn-success {{ titleNew }}
  br
</template>

<script>
export default {
  name: 'PageHeader',
  props: ['title', 'titleNew', 'url', 'voltar', 'voltarUrl'],
  methods: {
    getUrl() {
      if(this.voltarUrl) {
        return this.voltarUrl
      } else {
        return 'javascript:history.back()'
      }
    },
    getVoltar() {
      if(this.voltarUrl) {
        return this.$router.push(this.voltarUrl)
      } else {
        return 'javascript:history.back()'
      }
    }
  },
}
</script>
